import cleanTemplate from './template_clean.json'
import minimalTemplate from './template_minimal.json'
import executiveTemplate from './template_executive.json'
import elegantTemplate from './template_elegant.json'

/*
 * Professional colour systems applied to the established invoice layouts.
 * Keeping the underlying layout trees intact preserves all builder hooks,
 * document visibility rules, placeholders, and pagination behaviour.
 */
const createThemedTemplate = (template, replacements) => {
  const replaceTokens = value => {
    if (typeof value !== 'string') return value

    return replacements.reduce(
      (result, [from, to]) => result.split(from).join(to),
      value
    )
  }

  const visit = value => {
    if (Array.isArray(value)) return value.map(visit)
    if (value && typeof value === 'object') {
      return Object.keys(value).reduce((result, key) => {
        result[key] = visit(value[key])
        return result
      }, {})
    }
    return replaceTokens(value)
  }

  return visit(template)
}

export const corporateNavyTemplate = createThemedTemplate(cleanTemplate, [
  ['#111827', '#17324D'],
  ['#4b5563', '#465D73'],
  ['#6b7280', '#718397'],
  ['#9ca3af', '#91A1B2'],
  ['#d1d5db', '#B8C7D6'],
  ['#e5e7eb', '#DCE5ED'],
  ['#f9fafb', '#F3F7FA']
])

export const financeGreenTemplate = createThemedTemplate(minimalTemplate, [
  ['#111827', '#173F35'],
  ['#374151', '#31584E'],
  ['#6b7280', '#627B74'],
  ['#9ca3af', '#8FA69F'],
  ['#e5e7eb', '#D9E7E1']
])

export const burgundyClassicTemplate = createThemedTemplate(executiveTemplate, [
  ['#000000', '#542B38'],
  ['#000', '#542B38']
])

export const sandstoneTemplate = createThemedTemplate(elegantTemplate, [
  ['rgb(255, 255, 255)', 'rgb(255, 253, 249)'],
  ['#000000', '#47372F'],
  ['#333333', '#5A463B'],
  ['#666666', '#806F64'],
  ['#f8f9fa', '#F7F1E8'],
  ['#333', '#5A463B'],
  ['#666', '#806F64'],
  ['#000', '#47372F']
])

export default {
  corporateNavy: corporateNavyTemplate,
  financeGreen: financeGreenTemplate,
  burgundyClassic: burgundyClassicTemplate,
  sandstone: sandstoneTemplate
}
